'use client';
import classNames from 'classnames';
import { type ComponentProps, memo, type ReactNode } from 'react';
import { useInView } from 'react-intersection-observer';

export type MobileAssetModalNavigationProps = Pick<ComponentProps<'div'>, 'children'> & {
  suffix?: ReactNode;
};

export const MobileAssetModalNavigation = memo(({ children, suffix }: MobileAssetModalNavigationProps) => {
  const { ref: inViewRef, inView } = useInView();

  return (
    <div
      className="flex w-full shrink-0 items-center border-b ads:border-b-ads-gray-5 border-b-gray-5 ads:bg-base bg-gray-1"
      data-testid="MOBILE_ASSET_MODAL_NAVIGATION"
    >
      <div className="relative flex min-w-0 flex-1 overflow-hidden">
        <div className="flex w-full items-center gap-4 overflow-x-auto px-4 py-4">
          {children}
          <div className="h-full w-px shrink-0" ref={inViewRef} />
        </div>
        <div
          className={classNames(
            'pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-r from-transparent to-gray-1 transition-opacity',
            inView ? 'opacity-0' : 'opacity-100',
          )}
        />
      </div>
      {suffix && <div className="shrink-0 pr-4">{suffix}</div>}
    </div>
  );
});

MobileAssetModalNavigation.displayName = 'MobileAssetModalNavigation';
